import { useMutation, useQueryClient } from '@tanstack/react-query';
import { productKeys } from '@/features/products/hooks/useProductsQuery';
import { createProductFee, deleteProductFee, updateProductFee } from '../services/productFees';
import type { ProductFeePayload } from '../services/productFees';
import { productFeeKeys } from './useProductFeesQuery';

export function useProductFeeMutations(productId: string) {
    const qc = useQueryClient();

    const invalidate = () => {
        qc.invalidateQueries({ queryKey: productFeeKeys.list(productId) });
        qc.invalidateQueries({ queryKey: productKeys.detail(productId) });
    };

    const createMutation = useMutation({
        mutationFn: (payload: ProductFeePayload) => createProductFee(productId, payload),
        onSuccess: invalidate,
    });

    const updateMutation = useMutation({
        mutationFn: ({ id, payload }: { id: string; payload: Partial<ProductFeePayload> }) =>
            updateProductFee(productId, id, payload),
        onSuccess: invalidate,
    });

    const deleteMutation = useMutation({
        mutationFn: (id: string) => deleteProductFee(productId, id),
        onSuccess: invalidate,
    });

    return { createMutation, updateMutation, deleteMutation };
}
